export default function lazyLoadComponent({
  componentFactory,
  loading,
  loadingData
}) {
  let resolveComponent;

  return () => ({
    // We return a promise to resolve a
    // component eventually.
    component: new Promise(resolve => {
      resolveComponent = resolve;
    }),
    loading: {
      mounted() {
        const options = {
          thereshold: 1,
          root: null
        };
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Cleanup the observer when it's not
              // needed anymore.
              observer.unobserve(this.$el);
              // The `componentFactory()` resolves
              // to the result of a dynamic `import()`
              // which is passed to the `resolveComponent()`
              // function.

              setTimeout(() => {
                componentFactory().then(resolveComponent);
              }, 500);
            }
          });
        }, options);
        // We observe the root `$el` of the
        // mounted loading component to detect
        // when it becomes visible.
        observer.observe(this.$el);
      },
      // Here we render the the component passed
      // to this function via the `loading` parameter.
      render(createElement) {
        return createElement(loading, loadingData);
      }
    },
    delay: 1
  });
}
